// extracted by mini-css-extract-plugin
export default {"item":"NewsItem_item__xG1Yf","image":"NewsItem_image__sIxVG","skeleton":"NewsItem_skeleton__4Pm-e","date":"NewsItem_date__rppkI","title":"NewsItem_title__1lBt8"};